import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// Pipes
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { I18nNumberPipe } from './pipes/i18nNumber.pipe';
import { MomentPipe } from './pipes/moment.pipe';
import { CategoryFilterModule } from './pipes/category-filter/category-filter.module';

// Directives


// Modules
import { ThemeModule } from '../theme/theme.module';

// Drag'n'Drop
import { StaticPageDirective } from '../theme/directives/static-page.directive';
import {COLORS} from "./colors";


@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    CategoryFilterModule.forRoot()
  ],
  declarations: [
    StaticPageDirective,
    CurrencyFormatPipe,
    I18nNumberPipe,
    MomentPipe,
  ],
  exports: [
    CommonModule,
    StaticPageDirective,
    CurrencyFormatPipe,
    I18nNumberPipe,
    MomentPipe,
    ThemeModule,
    TranslateModule,
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/shared.module.ts